const W = 60;
const HR = "  " + "\u2500".repeat(W);
const HR2 = "  " + "\u2550".repeat(W);

function header(title: string): string[] {
  return ["", HR, `  ${title}`, HR, ""];
}

export const DISCLOSURES = [
  "",
  HR2,
  "  Skill Contest Disclosure & Recruiting Notice",
  HR2,
  "",
  "**1. Definitions",
  "",
  "  Contest \u2013 The skill-based engineering competition",
  "  operated by Moment Technology Inc.",
  "",
  "  Sponsor \u2013 Moment Technology Inc. and its affiliates.",
  "",
  "  Participant \u2013 Anyone who registers for or",
  "  participates in the Contest.",
  "",
  "  Score \u2013 Performance outputs generated by the Contest",
  "  (e.g., rank, points, timing, submission metrics,",
  "  evaluation results).",
  "",
  "  Public Scoreboard \u2013 Any public-facing page or feed",
  "  where Scores are displayed.",
  "",
  "  Handle \u2013 The name shown on the Public Scoreboard",
  "  (real name or pseudonym).",
  "",
  "  Prize \u2013 Any award, benefit, or reward offered in",
  "  connection with the Contest.",
  "",
  "  Winner \u2013 A Participant selected to receive a Prize.",
  "",
  "**2. Public Scoreboard",
  "",
  "**Publication of Results",
  "  By participating, you agree that your Score will be",
  "  displayed on the Public Scoreboard. Displayed",
  "  information may include your Handle, rank, and",
  "  relevant performance metrics.",
  "",
  "**Your Handle, Your Responsibility",
  "  You may use a pseudonym. You are responsible for",
  "  choosing your Handle and understanding that if it",
  "  identifies you, your participation and Score may",
  "  become publicly associated with you.",
  "",
  "**Public Means Public",
  "  The Public Scoreboard is intended to be openly",
  "  accessible. Scores and Handles may be viewed,",
  "  indexed, shared, cached, or redistributed by third",
  "  parties beyond Sponsor\u2019s control.",
  "",
  "**Integrity & Corrections",
  "  We may rescore, rerank, update, or remove entries to",
  "  correct errors, enforce rules, address abuse, or",
  "  protect Contest integrity. These changes may affect",
  "  rankings or Prize eligibility.",
  "",
  "**3. Recruiting Disclosure",
  "",
  "  The Contest may function as a talent discovery and",
  "  recruiting channel.",
  "",
  "  We may review Contest performance (including Scores",
  "  and rank) to identify and contact potential",
  "  candidates about employment or engagement",
  "  opportunities.",
  "",
  "  Participation, ranking, or receiving a Prize:",
  "  \u2022 Does not create an employment relationship,",
  "  \u2022 Does not guarantee an interview, and",
  "  \u2022 Is not an offer of employment.",
  "",
  "  Any employment or engagement would be subject to",
  "  separate agreements and applicable law.",
  "",
  "**4. Prize Conditions & Contact Information",
  "",
  "**Contact Required for Winners",
  "  To receive a Prize, a Winner must provide at least",
  "  one reliable contact method (e.g., email) and keep",
  "  it accurate until Prize fulfillment is complete.",
  "",
  "**Authorized Use",
  "  By accepting a Prize, a Winner authorizes Sponsor",
  "  to use their contact information to:",
  "  \u2022 Administer and deliver the Prize, and",
  "  \u2022 Reach out regarding potential work opportunities.",
  "",
  "  We are not responsible for failed Prize delivery",
  "  due to inaccurate or outdated contact information.",
  "",
  "**5. Prizes, Taxes, and Changes",
  "",
  "**Skill-Based Competition",
  "  The Contest is skill-based. Rankings and Prizes are",
  "  determined by Sponsor\u2019s scoring methodology.",
  "",
  "**Prize Structure",
  "  We may offer multiple Prizes and tiers. Details,",
  "  eligibility criteria, and quantities will be",
  "  described in the applicable Contest rules.",
  "",
  "**Taxes",
  "  Prizes may be subject to federal, state, local, or",
  "  international taxes. Winners are solely responsible",
  "  for any taxes, reporting obligations, or related",
  "  governmental charges arising from receiving a",
  "  Prize, unless applicable law requires otherwise.",
  "",
  "**Changes or Cancellation",
  "  We may modify, suspend, or cancel the Contest,",
  "  scoring system, Public Scoreboard, or Prize",
  "  structure as reasonably necessary to address",
  "  technical issues, fraud, abuse, security risks, or",
  "  legal requirements. We will act in good faith to",
  "  preserve the integrity of the Contest.",
  "",
  "**6. Use of Contest Data",
  "",
  "  You authorize Sponsor to:",
  "  \u2022 Display your Score and Handle on the Public",
  "    Scoreboard, and",
  "  \u2022 Use your Contest performance data internally for",
  "    evaluation and recruiting purposes.",
  "",
  "  You understand that publicly shared information may",
  "  be further redistributed by others and may no",
  "  longer be under Sponsor\u2019s control.",
  "",
  "**7. Governing Law",
  "",
  "  This Clause and any dispute related to the Contest",
  "  or Prizes are governed by the laws of the State of",
  "  New York, without regard to conflict-of-laws",
  "  principles. Exclusive venue is in the state or",
  "  federal courts located in New York, New York.",
  "",
];

export const WELCOME_BRIEF = `  MOMENT // ENGINEERING
${HR}

  A terminal for the engineering team at Moment --
  experiments, challenges, and other collateral.

  Type "about" to learn about Moment.
  Type "help" for available commands.
  `.split("\n");

export const ABOUT_MOMENT = [
  ...header("ABOUT MOMENT"),

  "  Moment builds software for investment management.",
  "",
  "  We work with some of the world's largest wealth",
  "  firms: 60,000+ advisors and over $10T in assets run",
  "  on our platform.",
  "",
  "  Engineering works on distributed systems, applied",
  "  AI, platform, security, and product.",
  "",
  "  We're hiring.",
  "  -> moment.com/careers",
  "",
];

export const HELP_TEXT = [
  "",
  "  Available commands:",
  "",
  "  about        Learn about Moment",
  "  theme        Change color theme",
  "  initialize   Configure boot animation",
  "  restart      Reboot to initialization screen",
  "  clear        Clear the terminal",
  "  help         Show this help message",
  "",
];

export const WHOAMI_TEXT = [
  "",
  "  > you are an engineer.",
  "  > ",
  "  > you stare at a blank editor and think:",
  '  > "i can make this cooperate."',
  "  > ",
  "  > you stare at a blank editor and think:",
  '  > "should i be running more parallel claude codes?"',
  "  > ",
  "  > you are ambitious. but token poor.",
  "",
  '  type "help" for available commands',
  "",
];
